import React, { Component } from 'react';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import RequestResetForm from './Layout/RequestResetForm';
import Wrapper from './Layout/Wrapper';

class RequestReset extends Component{

    render(){
        const { alert: { requestReset } } = this.props;
        return (
            <Wrapper>
                { requestReset !== false && 
                    <Alert color={requestReset.type}>
                        {requestReset.message}
                        {requestReset.type === 'success' && 
                            <div><Link to='/'>Login</Link></div>
                        }
                    </Alert> 
                }
                <RequestResetForm/>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    alert: state.auth.alert,
});

export default connect(mapStateToProps)(RequestReset);


// WEBPACK FOOTER //
// ./src/Components/Auth/RequestReset.js